module.exports = __webpack_public_path__ + "svg/icon-flag-left.svg";